import { ListItemIndustry } from "@similarweb/ui-components";
import DisabledTooltip from "../../../segments/components/DisabledTooltip";
import { AutocompleteItemWrapper } from "../../../segments/styles";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";

type IndustryItemProps = {
    item: IFlattenedCategory;
    onSelect: (item: IFlattenedCategory) => void;
    isDisabled: boolean;
};

const IndustryItem = ({ item, onSelect, isDisabled }: IndustryItemProps) => (
    <AutocompleteItemWrapper>
        <ListItemIndustry
            iconClassName={item.icon}
            key={item.name}
            onClick={() => onSelect(item)}
            text={item.name || item.text}
            disabled={isDisabled}
        />
        {isDisabled ? (
            <DisabledTooltip
                tooltipText={
                    isDisabled ? "dashboard.wizard.categories.autocomplete.item.industry.segments.limit.tooltip" : null
                }
                isGroup={false}
            />
        ) : null}
    </AutocompleteItemWrapper>
);

export default IndustryItem;
